<!-- Title -->
<h2 
  mat-dialog-title 
  *ngIf="dialogData?.title"
  class="dialog-title"
>
  <span class="title-text">{{ dialogData.title }}</span>

  <button 
    mat-icon-button 
    *ngIf="dialogData.enableClose" 
    class="close-btn" 
    (click)="cancel()"
  >
    <mat-icon class="text-hint">close</mat-icon>
  </button>
</h2>

<!-- Content -->
<mat-dialog-content class="mat-typography dialog-content">
  <div *ngIf="dialogData?.messageSegments?.length" class="mb-4">
    <h3 style="margin-bottom: 0px;" class="mat-subtitle-1">
      <ng-container *ngFor="let seg of dialogData.messageSegments">
        <b *ngIf="seg.bold">{{ seg.text }}</b>
        <ng-container *ngIf="!seg.bold">{{ seg.text }}</ng-container>
      </ng-container>
    </h3>
  </div>
  <div *ngIf="dialogData?.message" class="mb-4">
    <h3 style="margin-bottom: 0px;" [class.preserve-line-breaks]="dialogData.message?.includes('\n')" class="mat-subtitle-1">{{ dialogData.message }}</h3>
  </div>

  <!-- Optional list rendering -->
  <ol *ngIf="dialogData?.list?.length"
      class="dialog-list"
      [style.padding-left.px]="dialogData.listStyles ? null : 18"
      [attr.style]="dialogData.listStyles">
    <li *ngFor="let listItem of dialogData.list" class="dialog-list-item">
      <p>{{ listItem }}</p>
    </li>
  </ol>
  <div *ngIf="dialogData?.footerMessage" class="mt-4"><p class="mat-body-1">{{ dialogData.footerMessage }}</p></div>
</mat-dialog-content>

<!-- Actions -->
<mat-dialog-actions class="dialog-actions" align="end" [ngClass]="dialogData?.buttonContainerClass">
  <ng-container *ngIf="!dialogData?.enableClose; else closeEnableActions">
    
    <!-- Cancel Button -->
    <button
    class="mat-button"
      mat-button
      mat-dialog-close
      [color]="dialogData?.actionColor?.cancel || 'accent'"
      (click)="cancel()">
      {{ dialogData?.actions?.cancel }}
    </button>

    <!-- OK Button (normal) -->
    <button
    class="mat-button"

      *ngIf="!dialogData?.actionTypes?.ok"
      mat-button
      mat-dialog-close
      [color]="dialogData?.actionColor?.ok || 'accent'"
      (click)="send()">
      {{ dialogData?.actions?.ok }}
    </button>

    <!-- OK Button (flat) -->
    <button

      *ngIf="dialogData?.actionTypes?.ok === 'flat-button'"
      mat-flat-button
      mat-dialog-close
      [color]="dialogData?.actionColor?.ok || 'accent'"
      (click)="send()">
      {{ dialogData?.actions?.ok }}
    </button>
  </ng-container>

  <!-- If enableClose is true -->
  <ng-template #closeEnableActions>
    <button
        class="mat-button"

      mat-button
      mat-dialog-close
      (click)="cancel()">
      {{ dialogData?.actions?.cancel }}
    </button>

    <button

      mat-flat-button
      mat-dialog-close
      color="accent"
      (click)="send()">
      {{ dialogData?.actions?.ok }}
    </button>
  </ng-template>
</mat-dialog-actions>
